import { useQuery } from "@apollo/client";
import { Summary } from "./summary";
import { ComponentQueryLoader } from "../../../../../../shared/component-query-loader";
import { ApplicantCasesCredentialVerificationArchiveSummaryContainerApplicantUserDocument, ApplicantCasesCredentialVerificationArchiveSummaryContainerArchivedCredentialVerificationCaseSummaryDocument, ApplicantCasesCredentialVerificationArchiveSummaryContainerArchivedCredentialVerificationCaseSummaryFieldsFragment } from "../../../../../../../generated";


interface SummaryContainerProps {
  data: {
    caseId: string;
    applicantId: string;
  };
}

export const SummaryContainer: React.FC<SummaryContainerProps> = (props) => {
  const { data, loading, error } = useQuery(ApplicantCasesCredentialVerificationArchiveSummaryContainerArchivedCredentialVerificationCaseSummaryDocument, {
    variables: {
      archivedCredentialVerificationCaseSummaryId: props.data.caseId,
    },
    context: {
      headers: {
        "cache-enabled": "true"
      }
    }
  });

  const {
    data: applicantData,
    loading: applicantLoading,
    error: applicantError,
  } = useQuery(ApplicantCasesCredentialVerificationArchiveSummaryContainerApplicantUserDocument, {
    variables: {
      id: props.data.applicantId,
    },
  });

  return (
    <ComponentQueryLoader
      loading={loading && applicantLoading}
      error={error || applicantError}
      hasData={data !== undefined && applicantData !== undefined}
      hasDataComponent={
        <Summary
          data={data?.archivedCredentialVerificationCaseSummary as ApplicantCasesCredentialVerificationArchiveSummaryContainerArchivedCredentialVerificationCaseSummaryFieldsFragment}
        />
      }
    />
  );
};

